import Vue from 'vue'
import CreateAPI from 'vue-create-api'
import TabMessageDialog from 'components/TabMessageDialog'
import Notify from 'components/Notify'

Vue.use(CreateAPI)

Vue.createAPI(TabMessageDialog, true)
Vue.createAPI(Notify, true)

export const MessageDialog = TabMessageDialog
